import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section id="guarantee" className="py-24 px-4 md:px-8 bg-cream relative" data-id="element-82">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-83">
        <FadeIn data-id="element-84">
          <div className="relative bg-gradient-to-br from-white to-rose-light/20 p-10 md:p-14 rounded-[2.5rem] shadow-xl border border-rose/20 text-center" data-id="element-85">
            {/* Animated Shield */}
            <motion.div initial={{
            scale: 0,
            rotate: -15
          }} whileInView={{
            scale: 1,
            rotate: 0
          }} viewport={{
            once: true
          }} transition={{
            type: 'spring',
            bounce: 0.4,
            delay: 0.2
          }} className="w-24 h-24 rounded-full bg-gradient-to-br from-gold/20 to-gold/5 flex items-center justify-center mx-auto mb-8 border-2 border-gold/30" data-id="element-86">
              <ShieldCheckIcon className="w-12 h-12 text-gold-dark" data-id="element-87" />
            </motion.div>

            <h2 className="text-3xl md:text-4xl font-serif text-burgundy-dark mb-6" data-id="element-88">
              Garantía de Tranquilidad Total
            </h2>

            <p className="text-lg md:text-xl text-charcoal leading-[1.8] max-w-2xl mx-auto mb-6" data-id="element-89">
              Si dentro de los primeros{' '}
              <strong className="text-burgundy" data-id="element-90">7 días</strong> sientes que esta
              guía no te ha dado claridad ni herramientas reales para reconectar
              contigo misma y con tu pareja, te devolvemos el 100% de tu dinero.
              Sin preguntas, sin complicaciones.
            </p>

            <p className="text-lg text-charcoal-light italic font-serif" data-id="element-91">
              Tu inversión está completamente protegida. El único riesgo es
              seguir igual.
            </p>

            <div className="mt-8 flex items-center justify-center gap-3 text-gold-dark" data-id="element-92">
              <div className="w-12 h-[1px] bg-gold/40" data-id="element-93"></div>
              <ShieldCheckIcon className="w-5 h-5" data-id="element-94" />
              <div className="w-12 h-[1px] bg-gold/40" data-id="element-95"></div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}